module.exports = __webpack_public_path__ + "static/media/animation.7715e60b.gif";